// Действия с упражнением в списке (тренировка, шаблон): порядок стрелками, замена, техника,
// убрать. Полоса стоит в раскрытом упражнении, а не в заголовке — там остаётся место для
// названия. После стрелки страница прокручивается так, чтобы стрелки остались под пальцем.

import { useLayoutEffect, useRef, useState } from 'react'

import { Button, IconButton } from '@/components/ui'
import { cn } from '@/lib/cn'
import { useCatalogExercise, type Exercise } from '@/pages/workouts/api'

import { ExerciseInfoSheet } from './ExerciseInfo'
import { ExercisePicker } from './ExercisePicker'

export function ExerciseActions({
  exerciseId,
  name,
  index,
  total,
  onMove,
  onReplace,
  onRemove,
  className,
}: {
  exerciseId: string
  name: string
  index: number
  total: number
  onMove: (delta: -1 | 1) => void
  onReplace: (exercise: Exercise) => void
  onRemove: () => void
  className?: string
}) {
  const [info, setInfo] = useState(false)
  const [replacing, setReplacing] = useState(false)
  const muscle = useCatalogExercise(exerciseId)?.primary_muscle ?? ''
  const ref = useRef<HTMLDivElement>(null)
  // Где была полоса до перемещения: после него вернуть её на то же место экрана.
  const before = useRef<number | null>(null)
  useLayoutEffect(() => {
    const top = before.current
    before.current = null
    if (top === null || !ref.current) return
    const shift = ref.current.getBoundingClientRect().top - top
    if (Math.abs(shift) > 1) window.scrollBy({ top: shift })
  }, [index])
  const move = (delta: -1 | 1) => {
    before.current = ref.current?.getBoundingClientRect().top ?? null
    onMove(delta)
  }

  return (
    <div ref={ref} role="toolbar" aria-label={`Действия: ${name}`} className={cn('flex flex-wrap items-center gap-1', className)}>
      {total > 1 ? (
        <>
          <IconButton icon="arrow-up" label={`«${name}» выше`} disabled={index === 0} onClick={() => move(-1)} />
          <IconButton icon="arrow-down" label={`«${name}» ниже`} disabled={index === total - 1} onClick={() => move(1)} />
        </>
      ) : null}
      <Button size="sm" variant="ghost" icon="swap" onClick={() => setReplacing(true)}>
        Заменить
      </Button>
      {/* Подпись только у «Заменить»: на телефоне шириной 375 иначе полоса не помещается в строку. */}
      <IconButton icon="info" label={`Техника: ${name}`} onClick={() => setInfo(true)} />
      <IconButton icon="close" label={`Убрать упражнение «${name}»`} className="ml-auto text-danger" onClick={onRemove} />
      <ExerciseInfoSheet exerciseId={exerciseId} name={name} open={info} onClose={() => setInfo(false)} />
      {replacing ? (
        <ExercisePicker
          open
          title={`Заменить «${name}»`}
          initialMuscle={muscle}
          excludeId={exerciseId}
          onClose={() => setReplacing(false)}
          onPick={onReplace}
        />
      ) : null}
    </div>
  )
}
